// extracted by mini-css-extract-plugin
export var icon = "TelegramBotButton-module--icon--36eab";
export var mobileDark = "TelegramBotButton-module--mobileDark--6d991";
export var root = "TelegramBotButton-module--root--2b167";